import {
	ADD_EMAIL_FAIL,
	ADD_EMAIL_START, ADD_EMAIL_SUCCESS,
	GET_COMPANY_FAIL,
	GET_COMPANY_START,
	GET_COMPANY_SUCCESS,
	GET_USERS_COMPANY_FAIL,
	GET_USERS_COMPANY_START,
	GET_USERS_COMPANY_SUCCESS, REGISTER_COMPANY_USER_FAIL,
	REGISTER_COMPANY_USER_START, REGISTER_COMPANY_USER_SUCCESS,
	UPDATE_COMPANY_FAIL,
	UPDATE_COMPANY_START,
	UPDATE_COMPANY_SUCCESS,
} from "./actions/ActionTypes";

export const initReferenteState = () => {
	return {
		loadingUpdateCompany: true,
		errorUpdateCompany: "",
		
		loadingGetCompany: true,
		errorGetCompany: "",
		company: {},
		
		loadingGetUsers: true,
		errorGetUsers: "",
		users: [],
		
		loadingRegisterUser: true,
		errorRegisterUser: "",
		
		loadingSendEmail: true,
		errorSendEmail: "",
	}
}

export const REFERENTE_INITIAL_STATE = {};

export const ReferenteReducer = (state = REFERENTE_INITIAL_STATE, action) => {
	console.log(action);
	switch (action.type) {
		default:
			return state;
		
		
		case UPDATE_COMPANY_START:
			return {
				...state,
				loadingUpdateCompany: true,
				errorUpdateCompany: "",
			}
		case UPDATE_COMPANY_SUCCESS:
			return {
				...state,
				loadingUpdateCompany: false,
				errorUpdateCompany: "",
			}
		case UPDATE_COMPANY_FAIL:
			return {
				...state,
				loadingUpdateCompany: false,
				errorUpdateCompany: action.error,
			}
		case GET_COMPANY_START:
			return {
				...state,
				loadingGetCompany: true,
				errorGetCompany: "",
				company: {},
			}
		case GET_COMPANY_SUCCESS:
			return {
				...state,
				loadingGetCompany: false,
				errorGetCompany: "",
				company: action.payload,
			}
		case GET_COMPANY_FAIL:
			return {
				...state,
				loadingGetCompany: false,
				errorGetCompany: action.error,
				company: {},
			}
		case GET_USERS_COMPANY_START:
			return {
				...state,
				loadingGetUsers: true,
				errorGetUsers: "",
				users: [],
			}
		case GET_USERS_COMPANY_SUCCESS:
			return {
				...state,
				loadingGetUsers: false,
				errorGetUsers: "",
				users: action.payload,
			}
		case GET_USERS_COMPANY_FAIL:
			return {
				...state,
				loadingGetUsers: false,
				errorGetUsers: action.error,
				users: [],
			}
		case REGISTER_COMPANY_USER_START:
			return {
				...state,
				loadingRegisterUser: true,
				errorRegisterUser: "",
			}
		case REGISTER_COMPANY_USER_SUCCESS:
			return {
				...state,
				loadingRegisterUser: false,
				errorRegisterUser: "",
			}
		case REGISTER_COMPANY_USER_FAIL:
			return {
				...state,
				loadingRegisterUser: false,
				errorRegisterUser: action.error,
			}
		
		case ADD_EMAIL_START:
			return {
				...state,
				loadingSendEmail: true,
				errorSendEmail: "",
			}
		case ADD_EMAIL_SUCCESS:
			return {
				...state,
				loadingSendEmail: false,
				errorSendEmail: "",
			}
		case ADD_EMAIL_FAIL:
			return {
				...state,
				loadingSendEmail: false,
				errorSendEmail: action.error,
			}
	}
}
